import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function BoothManagement() {
  const [booths,   setBooths]   = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editBooth,setEditBooth]= useState(null);
  const [form,     setForm]     = useState({ name: '', location: '', characteristics: '' });
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState('');

  const load = () => api.getBooths().then(setBooths).catch(console.error);
  useEffect(() => { load(); }, []);

  const resetForm = () => {
    setForm({ name: '', location: '', characteristics: '' });
    setEditBooth(null); setShowForm(false); setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setError('');
    try {
      if (editBooth) { await api.updateBooth(editBooth.id, form); setSuccess('ブースを更新しました'); }
      else           { await api.createBooth(form);               setSuccess('ブースを追加しました'); }
      resetForm(); load();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) { setError(err.message); }
  };

  const handleDelete = async (booth) => {
    if (!window.confirm(`「${booth.name}」を削除します。\n過去のKPI・着座メモ・日報からこのブース名が外れます（元に戻せません）。\nよろしいですか？`)) return;
    try { await api.deleteBooth(booth.id); load(); }
    catch (err) { alert(err.message); }
  };

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const cardBase = {
    background: 'var(--field)',
    borderRadius: 12,
    border: '1px solid var(--rule-strong)',
    boxShadow: 'none',
  };

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 'var(--s6) var(--s4) 120px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, gap: 12, flexWrap: 'wrap' }}>
        <h1 className="page-title"style={{ marginBottom: 0 }}> ブース管理</h1>
        <button className="btn-primary" onClick={() => { resetForm(); setShowForm(true); }}>＋ ブース追加</button>
      </div>

      {success && <div className="alert-success">{success}</div>}

      {showForm && (
        <div style={{ ...cardBase, padding: '20px 22px', marginBottom: 16, borderColor: '#33406E' }} className="fade-in">
          <h2 style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', marginBottom: 16 }}>
            {editBooth ? 'ブース編集': 'ブース追加'}
          </h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <label style={{ fontSize: 'var(--t-note)', fontWeight: 600, color: 'var(--ink)' }}>ブース名 <span style={{ color: 'var(--loss)', fontSize: 'var(--t-note)' }}>必須</span></label>
                <input className="form-input" value={form.name} onChange={e => F('name', e.target.value)} placeholder="例: イオン〇〇店" required />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <label style={{ fontSize: 'var(--t-note)', fontWeight: 600, color: 'var(--ink)' }}>場所・住所</label>
                <input className="form-input" value={form.location} onChange={e => F('location', e.target.value)} placeholder="例: 東京都新宿区..." />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 14 }}>
              <label style={{ fontSize: 'var(--t-note)', fontWeight: 600, color: 'var(--ink)'}}> ブース特徴・メモ</label>
              <textarea
                className="form-input"
                value={form.characteristics}
                onChange={e => F('characteristics', e.target.value)}
                placeholder="例: シニア層が多い。入口付近で通行量多め。電力切り替え訴求が効きやすい..."
                rows={3}
                style={{ resize: 'vertical', minHeight: 70 }}
              />
            </div>
            {error && <div className="alert-error">{error}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" className="btn-secondary" onClick={resetForm}>キャンセル</button>
              <button type="submit" className="btn-primary">{editBooth ? '更新する' : 'ブースを追加'}</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ ...cardBase, overflowX: 'auto' }}>
        {booths.length === 0 ? (
          <div style={{ padding: 48, textAlign: 'center', color: 'var(--ink-mute)', fontSize: 'var(--t-note)' }}>ブースが登録されていません</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'var(--t-note)', minWidth: 420 }}>
            <thead>
              <tr style={{ background: 'var(--field)' }}>
                {['ブース名','場所','登録日','操作'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-soft)', borderBottom: '1px solid var(--rule-strong)', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {booths.map(b => (
                <tr key={b.id} style={{ borderBottom: '1px solid var(--rule-strong)' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, whiteSpace: 'nowrap', color: 'var(--ink)'}}> {b.name}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--ink-soft)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.location || '-'}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--ink-mute)', whiteSpace: 'nowrap' }}>{b.created_at?.slice(0, 10)}</td>
                  <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-edit" onClick={() => { setForm({ name: b.name, location: b.location || '', characteristics: b.characteristics || '' }); setEditBooth(b); setShowForm(true); }}>編集</button>
                      <button className="btn-danger" onClick={() => handleDelete(b)}>削除</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
